import * as types from './actionTypes'

export function authStateChanged(user) {
  return {type: types.AUTH_STATE_CHANGED, user};
}
